<template>
<div>
  <!-- {{ current_event }} -->
  <!-- {{outfield_pitcher}} -->
  <!-- {{ video }} -->
  <!-- {{ this.current_event.base_changes }} -->
  <div class="d-flex mb-2">
    <v-select :value="current_event.game_phase ? current_event.game_phase.jakso : ''" @input="setValue($event, 'game_phase.jakso')" v-no-focus class="short-select" label="Jakso" hide-details outlined :items="jakso_items"></v-select>
    <v-select :value="current_event.game_phase ? current_event.game_phase.inning : ''" @input="setValue($event, 'game_phase.inning')" v-no-focus class="short-select" label="VP" hide-details outlined :items="inning_items"></v-select>
    <v-select :value="current_event.game_phase ? current_event.game_phase.lopettava : ''" @input="setValue($event, 'game_phase.lopettava')" v-no-focus class="short-select" label="Vuoro" hide-details outlined :items="lopettava_items"></v-select>
  </div>
  <div class="mt-2 mb-2">
    <v-select
      :items="side_players"
      :value="current_event.bases ? current_event.bases[base]['id'] : null"
      @change="setValue($event, `bases.${base}.id`)"
      v-no-focus
      item-text="player_name"
      item-value="id"
      class="short-select"
      outlined
      hide-details
      dense
      v-for="(base, i_base) in hitter_base_items"
      :key="'player_base' + base"
    >
      <template v-slot:item="{item}">
        <span>{{item.num}}. </span>
        <span class="ml-2">{{item.player_name}}</span>
      </template>
      <template v-slot:selection="{item}">
        <span>{{item.num}}. </span>
        <span v-if="current_event && current_event.bases" class="ml-2">{{ current_event.bases[base].name }}</span>
      </template>
      <template v-slot:append>
        <v-icon color="primary" v-if="choosing_base === i_base">mdi-arrow-left</v-icon>
      </template>
    </v-select>
  </div>
  <div
    class="d-flex" style="width: 100%;"
    v-for="(base, i) in base_items"
    :key="base"
  >
    <v-btn
      @click="setValue(buttonChosen(base, outcome) ? null : outcome, `base_changes.${base}`)"
      v-no-focus
      class="flex-grow-1"
      style="margin: 0.5px;"
      v-for="(outcome, i2) in ['O', 'X', 'H']"
      x-small
      :key="outcome"
      :outlined="!buttonChosen(base, outcome)"
      :color="buttonChosen(base, outcome) ? 'primary' : ''"
    >
      <div class="d-flex align-center" style="width: 100%;">
        <div class="flex-grow-1 ml-2" style="font-size: 18px;">{{ outcome }}</div>
        <div style="width: 5px; font-size: 12px;" class="grey--text">{{ base_change_hotkeys[i][i2] }}</div>
      </div>
    </v-btn>
  </div>
  <div class="mt-1">
    <div class="d-flex justify-space-around">
      <!-- <number-selector v-if="pesis_league_name === 'msu'" info="Montako nyppyä ennen syöttöä" :not-important="false" @input="setValue($event, 'nypyt')" :value="current_event.nypyt" ref="nypyt" add-tooltip="Q" subtract-tooltip="Shift + Q" title="Heitot Q"></number-selector> -->
      <number-selector info="Montako kärkilyöntiä tällä lyönnillä" :not-important="false" @input="setValue($event, 'karkilyonnit')" :value="current_event.karkilyonnit" ref="karkilyonnit" add-tooltip="M" subtract-tooltip="Shift + M" :max="4" title="Kärkilyönnit M"></number-selector>
      <number-selector info="Montako paloa on taululla ennen lyöntiä" :not-important="true" @input="setValue($event, 'outs')" :value="current_event.outs" ref="outs" add-tooltip="X" subtract-tooltip="Shift + X" :max="2" title="Palot X"></number-selector>
    </div>
    <div class="d-flex justify-center mt-1">
      <number-selector class="mx-3" info="Monesko lyönti tämä on" :not-important="true" @input="setValue($event, 'hit_number')" :value="current_event.hit_number" ref="hit_number" add-tooltip="Shift + B" subtract-tooltip="B" :min="1" :max="3" title="Lyönti nro B"></number-selector>
      <number-selector class="mx-3" info="Lyödyt juoksut tällä lyönnillä" :not-important="true" @input="setValue($event, 'runs_created_this_hit')" :value="current_event.runs_created_this_hit" ref="runs_created_this_hit" add-tooltip="J" subtract-tooltip="Shift + J" :max="4" title="Juoksut J"></number-selector>
    </div>
    <!-- <number-selector ref="kls" add-tooltip="O" subtract-tooltip="J" v-model="num" :max="5" title="Kärkilyönnit"></number-selector> -->
  </div>
  <div class="mt-2 d-flex flex-wrap justify-center">
    <!-- MISC BUTTONS -->
    <div
      style="width: 33%;"
      class="d-flex justify-center"
      v-for="btn in misc_btns"
      :key="btn.path"
    >
      <v-btn
        v-no-focus
        :ref="btn.path"
        :color="current_event[btn.path] ? 'primary' : ''"
        :outlined="!current_event[btn.path]"
        @click="setValue(true, btn.path, false)"
        small
        v-tooltip="btn.tooltip"
        class="ml-1 mt-1"
      >{{ btn.text }}</v-btn>
    </div>
  </div>
  <div class="mt-2 d-flex d-flex-row justify-center align-center">
    <v-chip
      v-for="num in [10, 11, 12]"
      class="mr-2"
      :key="'joker-' + num"
      outlined
      v-no-focus
      small
      label
      @click="setBaseByNum(num, 'home')"
    >
      {{ side_players.find(p => p?.num === num)?.num }}
      {{ side_players.find(p => p?.num === num)?.player_name }}
    </v-chip>
  </div>
  <div class="d-flex d-flex-row align-center justify-center mt-3">
    <!-- // TODO: jos datan mukana ei tule lyöjän puolta -> herjaa siitä -->
    <span class="font-weight-bold">Lyöntipuoli</span>
    <v-btn v-tooltip="'Shift + V'" :color="current_event.hitter_side === 'R' ? 'primary' : ''" @click="setValue('R', 'hitter_side')" class="ml-2" :outlined="current_event.hitter_side !== 'R'" x-small>Oik</v-btn>
    <v-btn v-tooltip="'Shift + V'" :color="current_event.hitter_side === 'L' ? 'primary' : ''" @click="setValue('L', 'hitter_side')" class="ml-2" :outlined="current_event.hitter_side !== 'L'" x-small>Vas</v-btn>
  </div>
  <div class="d-flex justify-center mt-3" v-if="!current_event.event_id">
    <v-btn :color="current_event.starttime ? 'error' : ''" @click="handleStart" outlined x-small v-tooltip=" !current_event.starttime ? 'Aloita klippi (W)' : 'Peru klippi (W)'">{{ !current_event.starttime ? 'Aloita' : 'Peru' }}</v-btn>
    <v-btn @click="handleEnd" outlined :disabled="!current_event.starttime" x-small v-tooltip="'Luo klippi (D)'" class="ml-1">Lopeta</v-btn>
  </div>
  <div v-else class="d-flex justify-center mt-2">
    <v-btn color="error" x-small outlined @click="$emit('deleteEvent', current_event.event_id)">Poista eventti</v-btn>
    <v-btn color="primary" class="ml-2" x-small outlined @click="$emit('eventSaved')">Tallenna muutokset</v-btn>
  </div>
  <div class="d-flex justify-center mt-2">
    <v-btn @click="pickOffLatest" outlined x-small> Jatka viimeisestä eventistä (↑G)</v-btn>
    <v-btn v-if="current_event && !current_event.event_id" @click="hittersRanOut" outlined x-small class="ml-2">Lyöjät loppui</v-btn>
  </div>
  <div class="mt-2">
    <v-btn x-small rounded @click="showing_hotkeys = !showing_hotkeys">Hotkeys</v-btn>
    <v-btn x-small rounded @click="debugging = !debugging" class="ml-2">Debug</v-btn>
    <div v-if="debugging" class="d-flex flex-wrap">
      <v-chip class="d-flex" style="margin: 0.6px; width: 45%;" :color="chipColor(current_event[i])" outlined x-small v-for="i in debug_items" :key="i">
        <div>{{ i.substring(0, 34) }}: {{ current_event[i] }}</div>
      </v-chip>
    </div>
  </div>
  <v-dialog v-if="beaver" height="90vh" max-width="600" v-model="beaver">
    <div style="background-color: white;" class="py-10">
      <div class="d-flex justify-center">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/cZz1oamNbng?si=apKrHnsMvC8xTIMF&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
      <div class="d-flex justify-center">
        Tsemppiä! - Kiinalainen majava
      </div>
    </div>
  </v-dialog>
</div>
</template>

<script>
import NumberSelector from '@/components/analysis/small/NumberSelector.vue';
import { mapGetters } from 'vuex';
import { mapActions, mapMutations } from 'vuex/dist/vuex.common.js';
import { v4 as uuidv4 } from 'uuid';
import { getValueFromPath, validateField } from '@/utils/analysis/analysisHelper';
import funcs from '@/utils/analysis/analysisHelperFunctions';

export default {
  name: 'EventDetailsAnalysis',
  props: ['value'],
  components: {
    NumberSelector
  },
  mounted() {
    // called everytime user comes back to this tab
    if(this.current_event.event_id) {
      // modifying event
    } else {
      // creating new event
      this.SET_CREATING_EVENT_SILENT(this.emptyState())
    }

    this.SET_EVENTS_FILTER_FUNCTION(null)
  },
  methods: {
    ...mapMutations('analysis', [
      'SET_CREATING_EVENT',
      'SET_CREATING_EVENT_SILENT',
      'SET_EVENTS_FILTER_FUNCTION'
    ]),
    ...mapActions('analysis', [
      'setEventProperty',
      'setEventPropertySilently'
    ]),
    ...mapActions('noti', [
      'showSnackbar',
      'error'
    ]),
    setValue(val, path, ifEqual, event = this.current_event) {
      // handle new value correctly
      let previousValue = getValueFromPath(event, path)
      let newValue = val

      if(previousValue === val && ifEqual !== undefined) {
        newValue = ifEqual
      }

      const item = this.state[path]
      if(item) validateField(item.type, newValue, !item.required, item)

      this.setEventProperty({ val: newValue, path });

      if(!item) {
        return
      }


      this.$nextTick(() => {
        // handle children reqcursively
        const item = this.state[path]
        if(!item) return
        const children = item.parentOf ? Object.keys(item.parentOf) : []

        for(let i = 0; i < children.length; i++) {
          const oldChildValue = getValueFromPath(event, children[i])
          // run the parentOf function and get the new value of child
          const allPlayers = this.game_players.home.concat(this.game_players.away)
          let childNewValue = item.parentOf[children[i]](this.current_event, path, previousValue, newValue, oldChildValue, this.side_players, allPlayers)
          this.setValue(childNewValue, children[i], undefined, this.current_event)
        }
      })
    },
    skipHitter() {
      const num = this.current_event.hitter_number
      const next_num = num > 8 ? 1 : num + 1
      const next_hitter = this.side_players.find(p => p.num === next_num)
      this.setValue(next_hitter.id, 'bases.home.id')
    },
    setBase(player_id, base) {
      if(!player_id) {
        this.setValue(null, `bases.${base}.id`)
        this.setValue(null, `bases.${base}.name`)
      }
      this.setValue(player_id, `bases.${base}.id`)
      const player_name = this.side_players.find(p => p.id === player_id).player_name
      this.setValue(player_name, `bases.${base}.name`)
    },
    setBaseByNum(num, base) {
      const player = this.side_players.find(p => p.num === num)
      this.setValue(player.id, `bases.${base}.id`)
    },
    changeTeam() {
      this.SET_CREATING_EVENT_SILENT(this.emptyState(this.current_event.hitting === "home" ? "away" : "home"), true)
    },
    handleStart() {
      if(!this.current_event.starttime) {
        this.setValue(this.accurateCurrentTime, 'starttime')
      } else {
        this.setValue(null, 'starttime')
        this.setValue(null, 'endtime')
      }
    },
    handleEnd() {
      if(!this.current_event.starttime) return
      this.setValue(this.accurateCurrentTime, 'endtime')

      // check lyöntipuoli
      if(!this.current_event.hitter_side) {
        this.showSnackbar({ text: 'Merkkaa lyöntipuoli', type: 'error' })
        return
      }

      this.$nextTick(() => {
        this.$emit('eventSaved')
      })
    },
    buttonChosen(base, outcome) {
      if(!this.current_event) return false
      if(!this.current_event.base_changes) return false
      return this.current_event.base_changes[base] === outcome
    },
    chooseAllColumn(outcome) {
      this.base_items.forEach((b, i) => {
        if( this.current_event.bases[this.hitter_base_items[i]].id ) this.setValue(outcome, `base_changes.${b}`, false)
      })
    },
    pickOffLatest() {
      this.$emit('pickOffLatest')
    },
    hittersRanOut() {
      this.$emit('hittersRanOut')
    },
    handleButtonHotkey(key, outcome, path) {
      this.$doubleTap.handle(key, {
        double: () => this.chooseAllColumn(outcome),
        immediateSingle: () => this.setValue(outcome, path, null)
      })
    },
    chipColor(val) {
      if(typeof val === 'boolean') return 'green'
      if(typeof val === 'string') return 'primary'
      if(typeof val === 'number') return 'orange'
      return 'grey'
    },
    handleShiftUp() {
      if(this.choosing_base === null) this.choosing_base = 3
      else if(this.choosing_base === 0) this.choosing_base = 3
      else this.choosing_base--
      return this.choosing_base
    },
    handleShiftDown() {
      if(this.choosing_base === null) this.choosing_base = 0
      else if(this.choosing_base === 3) this.choosing_base = 0
      else this.choosing_base++
      return this.choosing_base
    },
    handleCtrlShiftDown() {
      const current = this.hitter_base_items[this.choosing_base]
      const going_to_index = this.handleShiftDown()
      this.switchBases(current, this.hitter_base_items[going_to_index])
    },
    handleCtrlShiftUp() {
      const current = this.hitter_base_items[this.choosing_base]
      const going_to_index = this.handleShiftUp()
      this.switchBases(current, this.hitter_base_items[going_to_index])
    },
    switchBases(base1, base2) {
      const temp = this.current_event.bases[base1] || { id: null }
      this.setBase(this.current_event.bases[base2].id, base1)
      this.setBase(temp.id, base2)
    },
    getChoosingBaseEnum() {
      if(!this.choosing_base) return 'home'
      else return this.hitter_base_items[this.choosing_base]
    },
    emptyState(hitting, keep_game_phase = false) {
      if(!hitting) hitting = "home"
      const fielding = hitting === 'home' ? 'away' : 'home'

      const hitter = this.game_players[hitting].find(p => p.num === 1)
      const pitcher = this.game_players[fielding].find(p => p.pos === 'L')

      let game_phase = this.current_event.game_phase
      if(!game_phase && !keep_game_phase) {
        game_phase = {
          jakso: 1,
          inning: 1,
          lopettava: false,
        }
      }

      return {
        phase_done: 1,
        bases: {
          home: { id: hitter.id, name: hitter.player_name },
          first: { id: null, name: null },
          second: { id: null, name: null },
          third: { id: null, name: null },
        },
        starttime: null,
        endtime: null,
        was_wrong: false,
        vvo: false,
        marked_laiton: false,
        marked: false,
        karkilyonnit: 0,
        hitter_side:
          hitter.hits_from_left === null
          ? null
          : hitter.hits_from_left ? 'L' : 'R',
        bases_state: '0',
        karkirunner_id: hitter.id,
        hitter_id: hitter.id,
        hitter_number: 1,
        joker_hitting: false,
        home_hitter_num: 1,
        away_hitter_num: 1,
        outs: 0,
        base_changes: {
          home_to_first: null,
          first_to_second: null,
          second_to_third: null,
          third_to_home: null,
        },
        vaara_alla: false,
        karpanen: false,
        vapaataival: false,
        // nypyt: this.pesis_league_name === 'msu' ? 0 : null,
        game_phase,
        hit_number: 1,
        hitting,
        pitch_happened: true,
        lapilyonti: false,
        hitter_name: hitter.player_name,
        karkirunner_name: hitter.player_name,
        hit_outcome: 'vapaa',
        pitcher_id: pitcher.id,
        pitcher_name: pitcher.player_name,
        hitting_team_id: hitting === "home" ? this.video.home_club_id : this.video.away_club_id,
        fielding_team_id: hitting === "away" ? this.video.home_club_id : this.video.away_club_id,
        plate_appearance_id: uuidv4(),
        after_marked_laiton: false,
        previous_hit_id: null,
        outs_inflicted_this_hit: 0,
        outs_inflicted_plate_appearance_before_hit: 0,
        runs_created_this_hit: 0,
        runs_created_this_inning_before_hit: 0,
      }
    }
  },
  computed: {
    ...mapGetters('analysis', [
      'modifying_event_id',
      'creating_event',
      'current_event',
      'events'
    ]),
    ...mapGetters('player', [
      'accurateCurrentTime'
    ]),
    ...mapGetters('game', [
      'game_players'
    ]),
    ...mapGetters('videos', [
      'video',
      'pesis_league_name'
    ]),
    side_players() {
      return [{ player_name: null, id: null, num: null }].concat(this.game_players[this.current_event.hitting])
    },
    outfield_pitcher() {
      return this.game_players[this.current_event.hitting === 'home' ? 'away' : 'home'].find(p => p.pos === 'L')
    },
  },
  shortcuts: {
    // these are ok
    // q: function() { this.pesis_league_name === 'msu' ? this.$refs.nypyt.add_num() : '' },
    // shift_q: function() { this.$refs.nypyt.subtract_num() },
    x: function() { this.$refs.outs.add_num() },
    shift_x: function() { this.$refs.outs.subtract_num() },
    m: function() { this.$refs.karkilyonnit.add_num() },
    shift_m: function() { this.$refs.karkilyonnit.subtract_num() },
    b: function() { this.$refs.hit_number.add_num() },
    shift_b: function() { this.$refs.hit_number.subtract_num() },
    j: function() { this.$refs.runs_created_this_hit.add_num() },
    shift_j: function() { this.$refs.runs_created_this_hit.subtract_num() },
    // O
    8: function() { this.handleButtonHotkey('8', 'O', 'base_changes.home_to_first') },
    i: function() { this.handleButtonHotkey('i', 'O', 'base_changes.first_to_second') },
    k: function() { this.handleButtonHotkey('k', 'O', 'base_changes.second_to_third') },
    hyphen: function() { this.handleButtonHotkey(',', 'O', 'base_changes.third_to_home') },
    // X
    9: function() { this.handleButtonHotkey('9', 'X', 'base_changes.home_to_first') },
    o: function() { this.handleButtonHotkey('o', 'X', 'base_changes.first_to_second') },
    l: function() { this.handleButtonHotkey('l', 'X', 'base_changes.second_to_third') },
    dot: function() { this.handleButtonHotkey('.', 'X', 'base_changes.third_to_home') },
    // H
    0: function() { this.handleButtonHotkey('0', 'H', 'base_changes.home_to_first') },
    p: function() { this.handleButtonHotkey('p', 'H', 'base_changes.first_to_second') },
    ö: function() { this.handleButtonHotkey('ö', 'H', 'base_changes.second_to_third') },
    line: function() { this.handleButtonHotkey('-', 'H', 'base_changes.third_to_home') },
    // Other
    // setEventProperty -> setValue
    w: function() { this.handleStart() },
    d: function() { this.handleEnd() },
    a: function() { this.changeTeam() },
    c: function() { this.setValue(true, 'marked_laiton', false) },
    f: function() { this.setValue(true, 'was_wrong', false) },
    e: function() { this.setValue(true, 'marked', false) },
    y: function() { this.setValue(true, 'karpanen', false) },
    u: function() { this.setValue(true, 'vapaataival', false) },
    h: function() { this.setValue(true, 'after_marked_laiton', false) },
    shift_s: function() { this.setValue(true, 'pitch_happened', false) },
    shift_f: function() { this.setValue(true, 'vvo', false) },
    shift_l: function() { this.setValue(true, 'lapilyonti', false) },
    shift_g: function() { this.pickOffLatest() },
    shift_v: function() { this.setValue(this.current_event.hitter_side === "R" ? "L" : "R", 'hitter_side') },

    1: function() { this.setBaseByNum(10, this.getChoosingBaseEnum()) },
    2: function() { this.setBaseByNum(11, this.getChoosingBaseEnum()) },
    3: function() { this.setBaseByNum(12, this.getChoosingBaseEnum()) },
    shift_1: function() { this.setBaseByNum(1, this.getChoosingBaseEnum()) },
    shift_2: function() { this.setBaseByNum(2, this.getChoosingBaseEnum()) },
    shift_3: function() { this.setBaseByNum(3, this.getChoosingBaseEnum()) },
    shift_4: function() { this.setBaseByNum(4, this.getChoosingBaseEnum()) },
    shift_5: function() { this.setBaseByNum(5, this.getChoosingBaseEnum()) },
    shift_6: function() { this.setBaseByNum(6, this.getChoosingBaseEnum()) },
    shift_7: function() { this.setBaseByNum(7, this.getChoosingBaseEnum()) },
    shift_8: function() { this.setBaseByNum(8, this.getChoosingBaseEnum()) },
    shift_9: function() { this.setBaseByNum(9, this.getChoosingBaseEnum()) },
    shift_0: function() { this.setBase(null, this.getChoosingBaseEnum()) },
    shift_r: function() { this.skipHitter() },

    shift_d: function() { this.$emit('deleteEvent', this.current_event.event_id) },
    shift_ctrl_down: function() { this.handleCtrlShiftDown() },
    shift_ctrl_up: function() { this.handleCtrlShiftUp() },
    esc: function() { this.choosing_base = null },
    shift_ctrl_b: function() { this.beaver = true },
  },
  data: () => ({
    beaver: false,
    choosing_base: null, // 0 = home, 1 = first, 2 = second, 3 = third
    debugging: false,
    misc_btns:     [
      { tooltip: 'Merkattu laiton (C)', text: 'M laiton (C)', path: 'marked_laiton' },
      { tooltip: 'Väärä syöttö (F)', text: 'Väärä (F)', path: 'was_wrong' },
      { tooltip: 'Väärä vedottu oikea syöttö (Shift + F)', text: 'VVO (↑F)', path: 'vvo' },
      { tooltip: 'Merkattu lyönti (myös viivästetty) (E)', text: 'Merkattu (E)', path: 'marked' },
      { tooltip: 'Laittoman jälkeinen turha lyönti. Jos etenijä kerkeää lyönnille -> ota pois (H)', text: 'Lait. jälk. (H)', path: 'after_marked_laiton' },
      { tooltip: 'Kärpänen (Y)', text: 'Kärpänen (Y)', path: 'karpanen' },
      { tooltip: 'Vapaataival (U)', text: 'Vapaataival (U)', path: 'vapaataival' },
      { tooltip: 'Läpilyönti (Shift + L)', text: 'Läpäri (↑L)', path: 'lapilyonti' },
      { tooltip: 'Syötetty (Shift + S)', text: 'Syöttö (↑S)', path: 'pitch_happened' },
    ],
    num: 0,
    jakso_items: [
      { text: '1.', value: 1 },
      { text: '2.', value: 2 },
      { text: 'Super', value: 3 },
      { text: 'Kotari', value: 4 },
    ],
    inning_items: [1, 2, 3, 4],
    lopettava_items: [
      { text: 'A', value: false},
      { text: 'L', value: true},
    ],
    base_items: ['home_to_first', 'first_to_second', 'second_to_third', 'third_to_home'],
    hitter_base_items: ['home', 'first', 'second', 'third'],
    debug_items: ["event_id", "after_marked_laiton", "hitter_id", "hitter_name", "karkirunner_id", "karkirunner_name", "pitcher_id", "pitcher_name", "bases_state", "hitter_number", "hitting_team_id", "fielding_team_id", "joker_hitting", "plate_appearance_id", "previous_hit_id", "hit_outcome", "hitting", "outs_inflicted_this_hit", "outs_inflicted_plate_appearance_before_hit", "runs_created_this_hit", "runs_created_this_inning_before_hit", "vaara_alla", "home_hitter_num", "away_hitter_num"],
    state: {
      "phase_done": {
        required: true
      },
      "bases.home.id": {
        type: 'number',
        required: false,
        parentOf: {
          "karkirunner_id": funcs.findRunnerId,
          "hitter_id": e => e.bases.home.id,
          "bases.home.name": (e, a, b, c, d, players) => players.find(p => p.id === e.bases.home.id)?.player_name || null,
          "bases_state": funcs.basesState,
          "karkilyonnit": funcs.karkilyonnit,
          "hit_outcome": funcs.hitOutcome,
        }
      },
      "bases.first.id": {
        type: 'number',
        required: false,
        parentOf: {
          "karkirunner_id": funcs.findRunnerId,
          "bases.first.name": (e, a, b, c, d, players) => players.find(p => p.id === e.bases.first.id)?.player_name || null,
          "bases_state": funcs.basesState,
          "karkilyonnit": funcs.karkilyonnit,
          "hit_outcome": funcs.hitOutcome,
        },
      },
      "bases.second.id": {
        type: 'number',
        required: false,
        parentOf: {
          "karkirunner_id": funcs.findRunnerId,
          "bases.second.name": (e, a, b, c, d, players) => players.find(p => p.id === e.bases.second.id)?.player_name || null,
          "bases_state": funcs.basesState,
          "karkilyonnit": funcs.karkilyonnit,
          "hit_outcome": funcs.hitOutcome,
        },
      },
      "bases.third.id": {
        type: 'number',
        required: false,
        parentOf: {
          "karkirunner_id": funcs.findRunnerId,
          "bases.third.name": (e, a, b, c, d, players) => players.find(p => p.id === e.bases.third.id)?.player_name || null,
          "bases_state": funcs.basesState,
          "karkilyonnit": funcs.karkilyonnit,
          "hit_outcome": funcs.hitOutcome,
        },
      },
      "starttime": {
        type: 'number',
        required: false,
      },
      "endtime": {
        type: 'number',
        required: false,
        whenChanged: null // TODO
      },
      "was_wrong": {
        type: 'boolean',
        required: true,
        parentOf: {
          karkilyonnit: (e, pp, pov, pnv, oov) => { return pnv ? 0 : oov },
          vapaataival: (e, pp, pov, pnv, oov) => {
            if(e.bases_state === "0") return pnv
            return oov
          },
          "base_changes.home_to_first": (e, pp, pov, pnv, oov) => {
            if(e.bases_state === "0" && pnv) return "O"
            return oov
          },
        }
      },
      "vvo": {
        type: 'boolean',
        required: true,
        parentOf: {
        }
      },
      "marked_laiton": { // check
        type: 'boolean',
        required: true,
        parentOf: {
          'marked': (e, parentPath, parentOldValue, parentNewValue) => { return parentNewValue },
          'base_changes.home_to_first': (ev, parentPath, parentOldValue, parentNewValue, ownOldValue) => { return ev.hit_number === 3 ? 'X' : ownOldValue },
        },
      },
      "after_marked_laiton": {
        // Laittoman jälkeinen *turha* lyönti
        type: 'boolean',
        required: true
      },
      "marked": { // fully done
        type: 'boolean',
        required: true,
      },
      "karkilyonnit": {
        type: 'number',
        required: true,
        parentOf: {
          "runs_created_this_hit": funcs.runsCreatedThisHit,
          "lapilyonti": e => e.karkilyonnit > 1 ? true : false
        },
      },
      "hitter_side": {
        type: ["L", "R"],
        required: false,
      },
      "bases_state": {
        type: 'string',
        required: false,
        inning: () => '0'
      },
      "karkirunner_id": {
        type: 'number',
        required: false,
        parentOf: {
          "karkirunner_name": (e, a, b, newVal, d, players, all_players) =>
          {
            return all_players.find(p => p.id === newVal).player_name
          },
        },
      },
      "hitter_id": {
        type: 'number',
        required: false,
        required_at_save: true,
        parentOf: {
          hitter_name: (e, a, b, c, d, players) => players.find(p => p.id === e.hitter_id)?.player_name,
          hitter_number: (e, a, b, c, d, players) => players.find(p => p.id === e.hitter_id)?.num,
          hitter_side: funcs.hitterSide
        },
      },
      "hitter_number": {
        type: 'number',
        required: false,
        required_at_save: true,
        parentOf: {
          joker_hitting: (e) => e.hitter_number > 9,
          "away_hitter_num": (e, parentPath, parentOld, parentNew, ownOld) => { return e.hitting === "home" || parentNew > 9 ? ownOld : parentNew },
          "home_hitter_num": (e, parentPath, parentOld, parentNew, ownOld) => { return e.hitting === "away" || parentNew > 9 ? ownOld : parentNew },
        },
      },
      "joker_hitting": {
        type: 'boolean',
        required: true,
      },
      "home_hitter_num": {
        type: 'number',
        required: false,
      },
      "away_hitter_num": {
        type: 'number',
        required: false,
      },
      "outs": {
        required: true,
        type: 'number',
        parentOf: {
          "outs_inflicted_this_hit": funcs.outsInflicted,
        }
      },
      "base_changes.home_to_first": {
        type: ["O", "X", "H"],
        required: false,
        parentOf: {
          "runs_created_this_hit": funcs.runsCreatedThisHit,
          "marked": funcs.markedByBaseChange,
          "karkilyonnit": e => (e.was_wrong && e.bases_state === "0") ? 0 : funcs.karkilyonnit(e),
          "hit_outcome": funcs.hitOutcome,
          "outs_inflicted_this_hit": funcs.outsInflicted,
        },
      },
      "base_changes.first_to_second": {
        type: ["O", "X", "H"],
        required: false,
        parentOf: {
          "runs_created_this_hit": funcs.runsCreatedThisHit,
          "marked": funcs.markedByBaseChange,
          "karkilyonnit": funcs.karkilyonnit,
          "hit_outcome": funcs.hitOutcome,
          "outs_inflicted_this_hit": funcs.outsInflicted,
        },
      },
      "base_changes.second_to_third": {
        type: ["O", "X", "H"],
        required: false,
        parentOf: {
          "runs_created_this_hit": funcs.runsCreatedThisHit,
          "marked": funcs.markedByBaseChange,
          "karkilyonnit": funcs.karkilyonnit,
          "hit_outcome": funcs.hitOutcome,
          "outs_inflicted_this_hit": funcs.outsInflicted,
        },
      },
      "base_changes.third_to_home": {
        type: ["O", "X", "H"],
        required: false,
        parentOf: {
          "runs_created_this_hit": funcs.runsCreatedThisHit,
          "marked": funcs.markedByBaseChange,
          "karkilyonnit": funcs.karkilyonnit,
          "hit_outcome": funcs.hitOutcome,
          "outs_inflicted_this_hit": funcs.outsInflicted,
        },
      },
      "vaara_alla": {
        type: 'boolean',
        required: true,
      },
      "karpanen": {
        type: 'boolean',
        required: true,
      },
      "vapaataival": {
        type: 'boolean',
        required: true,
      },
      // "nypyt": {
      //   type: 'boolean',
      //   required: true,
      // },
      "game_phase.jakso": {
        type: [1, 2, 3, 4],
        required: true,
      },
      "game_phase.inning": {
        type: [1, 2, 3, 4],
        required: true,
      },
      "game_phase.lopettava": {
        type: 'boolean',
        required: true,
      },
      "hit_number": {
        type: [1, 2, 3],
        required: true,
      },
      "hitting": {
        type: ["home", "away"],
        required: true,
      },
      "pitch_happened": {
        type: 'boolean',
        required: true,
      },
      "lapilyonti": {
        type: 'boolean',
        required: true,
      },
      "hitter_name": {
        type: 'string',
        required: false,
        required_at_save: true,
      },
      "karkirunner_name": {
        type: 'string',
        required: false,
        required_at_save: true,
      },
      "hit_outcome": {
        type: ["vapaa", "palo", "karkilyonti", "takapalo", "haava_kt", "takaeteneminen"],
        required: true,
      },
      "pitcher_id": {
        type: 'number',
        required: true,
        parentOf: {
          "pitcher_name": (e, a, b, c, d, players) => players.find(p => p.id === e.pitcher_id)?.player_name
        }
      },
      "pitcher_name": {
        type: 'string',
        required: true,
      },
      "hitting_team_id": {
        type: 'number',
        required: true,
        parentOf: {
          "karkirunner_id": funcs.findRunnerId,
        }
      },
      "fielding_team_id": {
        type: 'number',
        required: true,
        parentOf: {
          "karkirunner_id": funcs.findRunnerId,
        }
      },
      "plate_appearance_id": {
        type: 'string',
        required: true,
      },
      "previous_hit_id": {
        type: 'string',
        required: false,
      },
      "outs_inflicted_this_hit": {
        type: [0, 1, 2, 3],
        required: true,
      },
      "outs_inflicted_plate_appearance_before_hit": {
        type: 'number',
        required: true,
      },
      "runs_created_this_hit": {
        type: 'number',
        required: true,
      },
      "runs_created_this_inning_before_hit": {
        type: 'number',
        required: true,
      }
    },
    base_change_hotkeys: [
      [ '8', '9', '0' ],
      [ 'i', 'o', 'p' ],
      [ 'k', 'l', 'ö' ],
      [ ',', '.', '-' ],
    ]
  })
  // This phase is the only one that potentially has an empty value
}
</script>

<style>
.short-select {
  height: 30px !important;
}

.short-select .v-input__control,
.short-select .v-input__slot {
  height: 30px !important;
  min-height: 30px !important;
}

.short-select .v-input__append-inner {
  margin-top: 3px !important;
}

.short-select .v-label {
  top: 5px !important;
}

.short-select .v-label--active {
  top: 18px !important;
}
</style>